import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { MdcCard, MdcCardContent, MdcGrid, MdcTypography } from 'ids-wc/dist/react/components';

export const ListHeader = () => {
  const { t } = useTranslationHelper('IRISPaymentHistory');

  return (
    <MdcCard background="transparent">
      <MdcCardContent>
        <MdcGrid row className="mb-2">
          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={t('date')} textAlign="left" variant="subtitle2" />
          </MdcGrid>
          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={t('status')} textAlign="left" variant="subtitle2" />
          </MdcGrid>
          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={t('contributionType')} textAlign="left" variant="subtitle2" />
          </MdcGrid>
          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={t('institution')} textAlign="left" variant="subtitle2" />
          </MdcGrid>
          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={'RF'} textAlign="left" variant="subtitle1" />
          </MdcGrid>
          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={t('paymentAmount')} textAlign="left" variant="subtitle2" />
          </MdcGrid>
        </MdcGrid>
      </MdcCardContent>
    </MdcCard>
  );
};
